export const getPercentangeFromDuration = (duration,lapsedTime ) => {
  const hr = new RegExp(/.*(?=Hr)/g).exec(duration) || 0;
  const min = new RegExp(/(?!= )\d*(?=Min)/g).exec(duration) || 0;
  const durationSec = hr * 60 * 60 + min * 60;
  const per = (lapsedTime * 100) / durationSec;
  return isNaN(per) ? "70" : per;
};
